import React from "react";

import { DataHelper } from "../../helpers";

import FieldFilter from "./FieldFielter";
import { FieldGroup } from "../../components";

const fieldWrapClass = (fromSearch) =>
  fromSearch ? "col-12 InputHundred" : "col InputHundred";

const ProductDetailedFields = ({
  categoryId,
  nameObject,
  readOnly,
  fromSearch = false,
}) => {
  const wrapClass = fieldWrapClass(fromSearch);
  const valueName = (key) =>
    nameObject ? `${nameObject}[values][${key}]` : `values[${key}]`;
  const refName = nameObject
    ? `${nameObject}[reference_number]`
    : "reference_number";

  const bagsFields = categoryId === DataHelper.BAGS_CATEGORY_ID && (
    <div className={fromSearch ? wrapClass : "col-md-6"}>
      <FieldFilter
        filter="color"
        placeholder="Colour"
        disabled={readOnly}
        name={valueName("color")}
        prependStaticOptions={[{ id: "", name: "All Colours" }]}
      />
    </div>
  );

  const watchesFields = categoryId === DataHelper.WATCHES_CATEGORY_ID && (
    <>
      <div className={wrapClass}>
        <FieldFilter
          filter="case_material"
          placeholder="Case Material"
          disabled={readOnly}
          name={valueName("case_material")}
          prependStaticOptions={[{ id: "", name: "All Case Materials" }]}
        />
      </div>
      <div className={wrapClass}>
        {categoryId && (
          <FieldGroup
            placeholder="Reference number"
            disabled={readOnly}
            name={refName}
          />
        )}
      </div>
      <div className={wrapClass}>
        <FieldFilter
          filter="case_diameter"
          placeholder="Case Size"
          disabled={readOnly}
          name={valueName("case_diameter")}
          prependStaticOptions={[{ id: "", name: "All Case Sizes" }]}
        />
      </div>
      <div className={wrapClass}>
        <FieldFilter
          filter="dial_color"
          placeholder="Dial Colour"
          disabled={readOnly}
          name={valueName("dial_color")}
          prependStaticOptions={[{ id: "", name: "All Colours" }]}
        />
      </div>
    </>
  );

  if (fromSearch) {
    return (
      <div className="product-detailed-fields product-detailed-fields--search">
        {bagsFields}
        {watchesFields}
      </div>
    );
  }

  return (
    <div className="row product-detailed-fields">
      <div className="col">
        {categoryId === DataHelper.BAGS_CATEGORY_ID && (
          <div className="row">{bagsFields}</div>
        )}
        {categoryId === DataHelper.WATCHES_CATEGORY_ID && (
          <div className="row">{watchesFields}</div>
        )}
      </div>
    </div>
  );
};

export default ProductDetailedFields;
